import React from 'react';
import RadioGroup from 'apollo-react/components/RadioGroup';
import Radio from 'apollo-react/components/Radio';
import FieldWrapper from '../../fields/FieldWrapper';

const RadioFieldInput = ({
  id,
  label,
  value,
  onChange,
  helperText,
  showError,
  disabled,
  required,
  columnStyle,
  options,
}) => {
  return (
    <FieldWrapper style={columnStyle}>
      <RadioGroup
        id={id}
        name={id}
        label={label}
        value={value || ''}
        onChange={onChange}
        helperText={helperText}
        error={showError}
        disabled={disabled}
        required={required}
      >
        {options.map((opt) => (
          <Radio key={opt.value} value={opt.value} label={opt.label} />
        ))}
      </RadioGroup>
    </FieldWrapper>
  );
};

export default RadioFieldInput;
